import { matchPath } from "react-router-dom";
import { AppPatternRouteProps, appPattern } from "routes";
import { History } from "history";

export function getAppIDFromHistory(history: History) {
    const match = matchPath<AppPatternRouteProps>(history.location.pathname, appPattern);
    return match?.params.id;
}
